//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { Spacer             } from 'components/Spacer.jsx';
import { PredicateView      } from './components/PredicateView/PredicateView.jsx';
import { InfoView           } from './components/InfoView/InfoView.jsx';
import { ExpressionView     } from './components/ExpressionView/ExpressionView.jsx';
import { ExpressionContext  } from './components/ExpressionContext/ExpressionContext.jsx';
import { TagView            } from './components/TagView/TagView.jsx';

//#endregion

//-----------------------------------------------------------------
export function RuleView() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();
  const { state } = useLocation();

  const { rule } = useContext( ExpressionContext );

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      height: 'calc( 100% )',
      width: '100%',
      boxShadow: 0,
      padding: '1rem',
      overflow: 'hidden',
      justifyContent: 'center',
      backgroundColor: theme.palette.background.secondary[theme.palette.mode]
    },
    border_1: {
      display: 'flex',
      // border: 'solid ' + theme.palette.primary[theme.palette.mode],
      borderRadius: '1rem',
      padding: '1rem',
      width: 'max-content',
    },
    border_3: {
      // border: 'solid ' + theme.palette.primary[theme.palette.mode],
      borderRadius: '1rem',
      padding: '1rem',
      width: 'max-content',
      height: '20%',
    },
    border_2: {
      display: 'grid',
      gridTemplateColumns : '1fr',
      gridTemplateRows    : 'auto 1fr',
      columnGap : '0.5rem',
      rowGap: '0.5rem',
      borderRadius: '1rem',
      width: '100%',
      justifyContent: 'center',
      minWidth: 'max-content',
      maxWidth: 'max-content',
      height: '100%',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.secondary[theme.palette.mode],
    },
    button_add: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white',
    },
    header: {
      display: 'flex',
      fontSize: '2rem',
    },
  }

  const CONTAINER = {
    sx: _styles.container,
  };
  const BORDER_2 = {
    style: _styles.border_2,
  };
    
  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    if( state?.type === 'template' || rule?.tags?.is_template === true ) {
      return (
        <Box {...CONTAINER}>
          <div { ...BORDER_2 } >
            <InfoView />
            <ExpressionView column='1' row='2'/>
          </div>
        </Box>
      );
    }

    return (
      <Box {...CONTAINER}>
        <div { ...BORDER_2 } >
          <InfoView       /> <TagView        />
          <PredicateView  /> <ExpressionView />
        </div>
      </Box>
    );
  }

  //#endregion

  return display();
}
